const TestsLayout = () => import('@/components/Dashboard/Views/TestViews/Layout/TestsLayout.vue')
const TestItems = () => import('@/components/Dashboard/Views/TestViews/TestItems.vue')
const TestItem = () => import('@/components/Dashboard/Views/TestViews/TestItem.vue')
const TestSports = () => import('@/components/Dashboard/Views/TestViews/TestSports.vue')
const DashboardLayout = () => import('@/components/Dashboard/Layout/DashboardLayout.vue')

export default {
  path: 'test',
  props: true,
  component: DashboardLayout,
  children: [
    {
      path: '',
      props: true,
      component: TestsLayout,
      children: [
        {
          path: 'items',
          component: TestItems,
          props: true,
        },
        {
          path: 'item/:itemId',
          component: TestItem,
          name: 'TestItem',
          props: true,
        },
        {
          path: 'sports',
          component: TestSports,
          props: true,
        },
      ],
    },
  ],
}
